/* =========================================================
   WEBHAUS PAGE TRANSITION — V1.2
   ========================================================= */

(() => {
  'use strict';

  const transition = document.getElementById(
    'webhaus-page-transition'
  );

  if (!transition) return;

  const TRANSITION_DURATION =
    parseInt(
      transition.dataset.duration,
      10
    ) || 500;

  let isTransitioning = false;

  /*
   * ---------------------------------------------------------
   * Check whether this page was reached through a
   * WebHaus transition.
   * ---------------------------------------------------------
   */

  let transitionPending = false;

  try {
    transitionPending =
      sessionStorage.getItem(
        'webhaus-page-transition'
      ) === 'true';

    if (transitionPending) {
      sessionStorage.removeItem(
        'webhaus-page-transition'
      );
    }
  } catch (error) {
    transitionPending = false;
  }

  /*
   * ---------------------------------------------------------
   * NEW PAGE
   * ---------------------------------------------------------
   */

  if (transitionPending) {
    document.body.classList.add(
      'webhaus-transition-active'
    );

    /*
     * The overlay is already visible because the
     * <html> class was added in <head>.
     *
     * Wait until the new page has loaded.
     */

    const revealPage = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {

          transition.classList.remove(
            'is-entering'
          );

          document.documentElement.classList.remove(
            'webhaus-transition-pending'
          );

          document.body.classList.remove(
            'webhaus-transition-active'
          );

        });
      });
    };

    if (document.readyState === 'complete') {
      revealPage();
    } else {
      window.addEventListener(
        'load',
        revealPage,
        { once: true }
      );
    }

  } else {

    /*
     * -------------------------------------------------------
     * NORMAL PAGE LOAD
     * -------------------------------------------------------
     */

    transition.classList.remove(
      'is-entering'
    );

    document.documentElement.classList.remove(
      'webhaus-transition-pending'
    );

  }

  /*
   * ---------------------------------------------------------
   * HELPERS
   * ---------------------------------------------------------
   */

  function isModifiedClick(event) {
    return (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    );
  }

  function isValidLink(link) {
    if (!link) return false;

    const href = link.getAttribute('href');

    if (!href) return false;

    /*
     * Ignore anchors.
     */

    if (href.startsWith('#')) {
      return false;
    }

    /*
     * Ignore special protocols.
     */

    if (
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) {
      return false;
    }

    /*
     * Ignore downloads.
     */

    if (link.hasAttribute('download')) {
      return false;
    }

    /*
     * Ignore new tabs/windows.
     */

    if (
      link.target &&
      link.target !== '_self'
    ) {
      return false;
    }

    let url;

    try {
      url = new URL(
        href,
        window.location.href
      );
    } catch {
      return false;
    }

    /*
     * Same-origin navigation only.
     */

    if (
      url.origin !==
      window.location.origin
    ) {
      return false;
    }

    /*
     * Ignore same-page navigation.
     */

    if (
      url.pathname ===
        window.location.pathname &&
      url.search ===
        window.location.search &&
      url.hash ===
        window.location.hash
    ) {
      return false;
    }

    return true;
  }

  /*
   * ---------------------------------------------------------
   * START TRANSITION
   * ---------------------------------------------------------
   */

  function startTransition() {
    if (isTransitioning) return;

    isTransitioning = true;

    /*
     * Tell the next document that it needs to begin
     * with the transition screen already visible.
     */

    try {
      sessionStorage.setItem(
        'webhaus-page-transition',
        'true'
      );
    } catch (error) {}

    document.body.classList.add(
      'webhaus-transition-active'
    );

    transition.classList.add(
      'is-entering'
    );
  }

  /*
   * ---------------------------------------------------------
   * NAVIGATION
   * ---------------------------------------------------------
   */

  function navigate(url) {
    window.location.href = url;
  }

  /*
   * ---------------------------------------------------------
   * LINK INTERCEPTION
   * ---------------------------------------------------------
   */

  document.addEventListener(
    'click',
    (event) => {

      if (event.defaultPrevented) return;

      if (isModifiedClick(event)) return;

      const link =
        event.target.closest('a');

      if (!isValidLink(link)) return;

      /*
       * Don't interfere with Shopify UI.
       */

      if (
        link.closest(
          'quick-add-modal, ' +
          'cart-drawer, ' +
          'search-modal, ' +
          'dialog, ' +
          '[data-modal], ' +
          '[data-drawer]'
        )
      ) {
        return;
      }

      event.preventDefault();

      startTransition();

      const url = link.href;

      /*
       * Allow the transition to fully cover
       * the current page before navigating.
       */

      setTimeout(() => {
        navigate(url);
      }, TRANSITION_DURATION);

    },
    true
  );

})();